
import * as defaultImport from "@splunk/visualizations-shared/RemoteIcon";
export * from "@splunk/visualizations-shared/RemoteIcon";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
